import EventEmitter from '../../../../utility/event-emitter';
import { calculateAudioScore, calculateVideoScore, estimateScore, } from './doxyme-opentok-mos';
import angular from 'angular';
import StatsMapperHelper from '../../../../providers/video/tokbox/lib/helpers/stats-mapper.helper';
import { RootScopeEvents } from '../../../../common/services/root-scope-types';
import { VideoProviderEvents } from '../video-provider-events';
let $log = null;
const getLogger = () => {
    return $log || ($log = angular.element(document.body).injector().get('$log'));
};
export const eventEmitter = new EventEmitter();
const ESTIMATION_SCALE = [
    'disconnected',
    'unstable',
    'poor',
    'fair',
    'excellent',
]; // from worst to best
const connectionIntervals = new Map();
const publisherIntervals = new Map();
export function watchConnections(videoProvider) {
    videoProvider.addListenerIfNotExists(VideoProviderEvents.ConnectionCreated, addConnection);
    videoProvider.addListenerIfNotExists(VideoProviderEvents.ConnectionDestroyed, deleteConnection);
    videoProvider.addListenerIfNotExists(VideoProviderEvents.SessionDisconnected, clearAllConnections);
}
export function watchPublishers($rootScope) {
    getLogger().debug('getStatsAnalyzer: watchPublishers');
    $rootScope.$on(RootScopeEvents.SESSION.PUBLISHER_CREATED, (e, publisher) => addPublisher(publisher));
    $rootScope.$on(RootScopeEvents.SESSION.PUBLISHER_DESTROYED, (e, publisher) => deletePublisher(publisher));
}
export function addConnection(connection) {
    if (connectionIntervals.has(connection.id))
        return;
    getLogger().debug(`getStatsAnalyzer: add connection ${connection.id}`);
    connectionIntervals.set(connection.id, analyzeConnection(connection));
}
export function deleteConnection(connection) {
    const { id } = connection;
    if (!connectionIntervals.has(id))
        return;
    getLogger().debug(`getStatsAnalyzer: delete connection ${id}`);
    removeInterval(connectionIntervals, id);
}
export function addPublisher(publisher) {
    const guid = publisher.guid();
    if (publisherIntervals.has(guid))
        return;
    getLogger().debug(`getStatsAnalyzer: add publisher ${publisher.guid()}`);
    publisherIntervals.set(guid, analyzePublisher(publisher));
}
export function deletePublisher(publisher) {
    const guid = publisher.guid();
    if (!publisherIntervals.has(guid))
        return;
    getLogger().debug(`getStatsAnalyzer: delete publisher ${publisher.guid()}`);
    removeInterval(publisherIntervals, guid);
}
export function clearAllConnections() {
    Array.from(connectionIntervals.keys()).forEach((connectionId) => {
        getLogger().debug(`getStatsAnalyzer: clear connection ${connectionId}`);
        removeInterval(connectionIntervals, connectionId);
    });
}
// window['ee'] = eventEmitter;
export async function analyzePublisher(publisher) {
    const publisherAudioScoresLog = [];
    const publisherVideoScoresLog = [];
    if (!publisher)
        return;
    const statsLog = [];
    const SCORES_LOG_LENGTH = 1000;
    const SCORE_INTERVAL = 1000;
    return window.setInterval(async function () {
        function getPublisherStats() {
            return new Promise((resolve) => {
                publisher.getStats((error, statsStream) => {
                    const mappedStream = StatsMapperHelper.mapStatsStream(statsStream);
                    resolve(mappedStream);
                });
            });
        }
        const pubStat = await getPublisherStats();
        if (!pubStat || !pubStat.length)
            return;
        const stats = pubStat[0].stats;
        if (!stats.video && !stats.audio)
            return;
        statsLog.push(stats);
        if (statsLog.length < 2) {
            return;
        }
        const videoScore = calculateVideoScore(publisher.videoElement(), statsLog, true);
        publisherVideoScoresLog.push(videoScore);
        const audioScore = calculateAudioScore(statsLog, true);
        publisherAudioScoresLog.push(audioScore);
        while (statsLog.length > SCORES_LOG_LENGTH) {
            statsLog.shift();
        }
        while (publisherAudioScoresLog.length > SCORES_LOG_LENGTH) {
            publisherAudioScoresLog.shift();
        }
        while (publisherVideoScoresLog.length > SCORES_LOG_LENGTH) {
            publisherVideoScoresLog.shift();
        }
        eventEmitter.emit('PublisherMOSUpdate', {
            videoScore,
            audioScore,
            publisherVideoScoresLog,
            publisherAudioScoresLog,
            publisher: publisher,
        });
    }, SCORE_INTERVAL);
}
async function analyzeConnection(connection) {
    const statsLog = [];
    const audioScoresLog = [];
    const videoScoresLog = [];
    const SCORES_LOG_LENGTH = 100;
    const SCORE_INTERVAL = 1000;
    let previousEstimation = 'excellent';
    const emitChangeEvent = (currentValue) => {
        if (!currentValue)
            return;
        if (currentValue === previousEstimation)
            return;
        const event = {
            currentValue,
            previousValue: previousEstimation,
            person: connection.person,
            deteriorated: !!previousEstimation &&
                ESTIMATION_SCALE.indexOf(currentValue) <
                    ESTIMATION_SCALE.indexOf(previousEstimation),
        };
        previousEstimation = currentValue;
        eventEmitter.emit('MOSChange', event);
    };
    return window.setInterval(async function () {
        const stream = connection.streams.find((stream) => stream.type === 'camera');
        if (!stream)
            return;
        const stats = await stream.getStats();
        if (!stats)
            return;
        if (!stats.video && !stats.audio)
            return;
        statsLog.push(stats);
        if (statsLog.length < 2) {
            return;
        }
        const videoScore = calculateVideoScore(stream.videoElement, statsLog);
        videoScoresLog.push(videoScore);
        if (videoScoresLog.length > SCORES_LOG_LENGTH) {
            videoScoresLog.shift();
        }
        const audioScore = calculateAudioScore(statsLog);
        audioScoresLog.push(audioScore);
        while (statsLog.length > SCORES_LOG_LENGTH) {
            statsLog.shift();
        }
        while (audioScoresLog.length > SCORES_LOG_LENGTH) {
            audioScoresLog.shift();
        }
        eventEmitter.emit('MOSUpdate', {
            videoScoresLog,
            audioScoresLog,
            person: connection.person,
        });
        const videoMeanEstimation = getMeanEstimation(videoScoresLog);
        const audionMeanEstimation = getMeanEstimation(audioScoresLog);
        let worstEstimation;
        switch (true) {
            case !!videoMeanEstimation && !!audionMeanEstimation:
                worstEstimation =
                    ESTIMATION_SCALE.indexOf(videoMeanEstimation) <
                        ESTIMATION_SCALE.indexOf(audionMeanEstimation)
                        ? videoMeanEstimation
                        : audionMeanEstimation;
                break;
            case !videoMeanEstimation:
                worstEstimation = audionMeanEstimation;
                break;
            case !audionMeanEstimation:
                worstEstimation = videoMeanEstimation;
                break;
            default:
                worstEstimation = null;
        }
        if (worstEstimation && previousEstimation != worstEstimation) {
            if (connection.person) {
                connection.person.state.connection =
                    connection.person.state.connection || {};
                connection.person.state.connection.level = worstEstimation;
            }
            emitChangeEvent(worstEstimation);
        }
    }, SCORE_INTERVAL);
}
function getMeanEstimation(log, period = 10) {
    const items = log
        .slice(log.length - period, log.length - 1)
        .filter((item) => item.score != null);
    if (items.length < period - 1)
        return null;
    const unstableCount = items.filter((item) => item.estimation === 'unstable').length;
    if (unstableCount >= period / 2)
        return 'unstable';
    let score = 0;
    let count = 0;
    items.forEach((item) => {
        score += item.score;
        count++;
    });
    return estimateScore(score / count);
}
export function removeInterval(intervalMap, key) {
    if (!intervalMap.has(key))
        return;
    intervalMap.get(key).then((handle) => {
        window.clearInterval(handle);
        intervalMap.delete(key);
    });
}
